"use client";

import React, { useEffect, useState } from "react";
import "@fortawesome/fontawesome-svg-core/styles.css";
import CurrencyConverter from "utils/CurrencyConverter";
import { useTranslation } from "react-i18next";
import customURLSearchParams from "services/CustomURLSearchParams";

export const SalaryFilter = ({ onChange, data, initialState, clearFilter }) => {
  const [selectedType, setSelectedType] = useState(
    (data &&
      data.salaries &&
      data.salaries.types &&
      data.salaries.types?.filter((x) => x.count > 0)[0]) ||
      {},
  );
  const [salaryRanges, setSalaryRanges] = useState([]);
  const [, setIsChecked] = useState(false);


  const params = customURLSearchParams();
  const salaryParam = params.get("salary");
  const salaryParams = salaryParam ? salaryParam.split("|") : [];
  const [
    salaryTypeId,
    salaryFrequency,
    salaryPeriod,
    salaryValue,
    salaryCurrency,
  ] = salaryParams;
  const salaryMinimum =
    salaryValue ||
    (initialState.value && initialState.value.salaryMinimum) ||
    "";
  const { t } = useTranslation();

  useEffect(() => {
    setIsChecked(salaryTypeId === (selectedType?.id || null));
  }, [
    salaryTypeId,
    selectedType,
    salaryFrequency,
    salaryPeriod,
    salaryCurrency,
  ]);

  const handleChangeSalaryMinimum = (minimum) => {
    onChange &&
      onChange({
        salaryType: selectedType,
        salaryMinimum: minimum,
        currencyCode: data.salaries.currencyCode,
      });
  };

  const handleChangeSalaryType = (e, type) => {
    e.preventDefault();
    setSelectedType(type);
  };

  useEffect(() => {
    if (
      initialState.value &&
      initialState.value.type &&
      data.salaries &&
      data.salaries.types
    ) {
      const typeIndex = data.salaries.types.findIndex(
        (type) => type.id === initialState.value.type.id,
      );
      if (typeIndex !== -1) {
        setSelectedType(initialState.value.type);
        setSalaryRanges(data.salaries.minimums[typeIndex]);
      }
    }
  }, [initialState.value, data.salaries]);

  useEffect(() => {
    if (
      selectedType &&
      selectedType.id &&
      data.salaries &&
      data.salaries.types
    ) {
      const typeIndex = data.salaries.types.findIndex(
        (type) => type.id === selectedType.id,
      );
      if (typeIndex !== -1) {
        setSalaryRanges(data.salaries.minimums[typeIndex]);
      }
    }
  }, [selectedType, data.salaries]);

  return (
    <>
      <div className="filters">
        <div className="filter">
          <div className="tabbed-filters">
            <ul className="nav" id="tabList" role="tablist">
              {data.salaries?.types
                ?.filter((x) => x.count > 0)
                .map((type) => (
                  <li key={type.id}>
                    <a
                      href={`#salarytype_${type.id}`}
                      className={selectedType.id === type.id ? "active" : ""}
                      id={`${type.id}-tab`}
                      data-bs-toggle="tab"
                      data-bs-target={`#salarytype_${type.id}`}
                      type="button"
                      role="tab"
                      aria-controls={type.id}
                      aria-selected={selectedType.id === type.id}
                      onClick={(e) => handleChangeSalaryType(e, type)}
                    >
                      {t(type.key.toLowerCase())}                      
                    </a>
                  </li>
                ))}
            </ul>
            <div className="tab-content" id="salary-options">
              {data.salaries?.types?.map((type) => (
                <div
                  className={`tab-pane ${
                    selectedType.id === type.id ||
                    data.salaries?.types.length === 1
                      ? "show active"
                      : "fade"
                  }`}
                  role="tabpanel"
                  id={`salarytype_${type.id}`}
                  key={type.id}
                >
                  {salaryRanges
                    ?.filter((x) => x.count > 0)
                    .map((minimum) => (
                      <div
                        className="element radio form-group"
                        key={minimum.key}
                      >
                        <div className="field">
                          <div className="icheck-primary">
                            <input
                              type="radio"
                              name={`${type.id}-minimum-list`}
                              id={minimum.key}
                              onClick={() =>
                                handleChangeSalaryMinimum(minimum.value)
                              }
                              checked={
                                Number(minimum.value) === Number(salaryMinimum)
                              }
                              onChange={() => {}}
                            />
                            <label className="" htmlFor={minimum.key}>
                              <CurrencyConverter
                                value={minimum.value}
                                currency={data?.salaries.currencyCode}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalaryFilter;
